"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextValue = void 0;

var symbols_1 = require("../../symbols");

var NextValue = /*#__PURE__*/function () {
  function NextValue(value_, context) {
    var customGetValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    _classCallCheck(this, NextValue);

    this.value_ = value_;
    this.context = context;
    this.hasToBeCloned = customGetValue !== undefined || (0, symbols_1.hasCloneMethod)(value_);
    this.readOnce = false;

    if (this.hasToBeCloned) {
      Object.defineProperty(this, 'value', {
        get: customGetValue !== undefined ? customGetValue : this.getValue
      });
    } else {
      this.value = value_;
    }
  }

  _createClass(NextValue, [{
    key: "getValue",
    value: function getValue() {
      if (this.hasToBeCloned) {
        if (!this.readOnce) {
          this.readOnce = true;
          return this.value_;
        }

        return this.value_[symbols_1.cloneMethod]();
      }

      return this.value_;
    }
  }]);

  return NextValue;
}();

exports.NextValue = NextValue;